// extracted by mini-css-extract-plugin
export default {"actions":"LeadEntrantes_actions__BuOps","year":"LeadEntrantes_year__I9N7U"};